var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "validation-observer",
        { ref: "validator" },
        [
          _c(
            "b-form",
            {
              on: {
                submit: function($event) {
                  $event.preventDefault()
                  return _vm.createOrUpdate($event)
                }
              }
            },
            [
              _c(
                "b-form-group",
                [
                  _c("select-suggestion", {
                    attrs: {
                      label: _vm.$t(
                        "reporting_channel.workflow_config.legal_entity"
                      ),
                      column: "company_name,trading_name,cnpj",
                      model: "LegalEntity",
                      appendClearOption: true,
                      placeholderText: _vm.$t(
                        "reporting_channel.workflow_config.legal_entity_placeholder"
                      ),
                      itemTextFormat: _vm.legalEntityItemTextFormat
                    },
                    model: {
                      value: _vm.selectedLegalEntity,
                      callback: function($$v) {
                        _vm.selectedLegalEntity = $$v
                      },
                      expression: "selectedLegalEntity"
                    }
                  }),
                  _c("small", { staticClass: "text-muted" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          "reporting_channel.workflow_config.legal_entity_hint"
                        )
                      )
                    )
                  ]),
                  _vm.errors.legal_entity_id
                    ? _c("small", { staticClass: "text-danger" }, [
                        _vm._v(_vm._s(_vm.errors.legal_entity_id[0]))
                      ])
                    : _vm._e()
                ],
                1
              ),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { md: "12" } },
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            label: _vm.$t(
                              "reporting_channel.workflow_config.description"
                            ),
                            "label-for": "description"
                          }
                        },
                        [
                          _c("b-form-textarea", {
                            attrs: {
                              id: "description",
                              rows: "3",
                              placeholder: _vm.$t(
                                "reporting_channel.workflow_config.description_placeholder"
                              ),
                              state: _vm.errors.description ? false : null
                            },
                            model: {
                              value: _vm.model.description,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "description", $$v)
                              },
                              expression: "model.description"
                            }
                          }),
                          _vm.errors.description
                            ? _c("small", { staticClass: "text-danger" }, [
                                _vm._v(_vm._s(_vm.errors.description[0]))
                              ])
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { md: "12" } },
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            label: "Realizar tratamento após triagem",
                            "label-for": "treat_after_screening"
                          }
                        },
                        [
                          _c("b-form-checkbox", {
                            staticClass: "mr-n2",
                            attrs: { id: "treat_after_screening", switch: "" },
                            model: {
                              value: _vm.model.treat_after_screening,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.model,
                                  "treat_after_screening",
                                  $$v
                                )
                              },
                              expression: "model.treat_after_screening"
                            }
                          }),
                          _vm.errors.treat_after_screening
                            ? _c("small", { staticClass: "text-danger" }, [
                                _vm._v(
                                  _vm._s(_vm.errors.treat_after_screening[0])
                                )
                              ])
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "mt-3 flex justify-end" },
                [
                  _c(
                    "b-button",
                    {
                      attrs: {
                        type: "submit",
                        variant: "primary",
                        disabled: !_vm.validateForm
                      }
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.id
                              ? _vm.$t("action.save")
                              : _vm.$t("action.create")
                          ) +
                          " "
                      )
                    ]
                  ),
                  _c(
                    "b-button",
                    {
                      staticClass: "ml-2",
                      attrs: { type: "button", variant: "outline-secondary" },
                      on: { click: _vm.handleBack }
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("action.back")) + " ")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }